import { render } from "./partnersPage.vue?vue&type=template&id=79c4691c"
import script from "./partnersPage.vue?vue&type=script&lang=js"
export * from "./partnersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__